@if (!isMobileApp) {
  <header class="spen-ly-global-header fixed-header" id="global-header">
    @if (authUserService.isLoggedIn) {
      <app-student-header></app-student-header>
    }
    <app-global-menu></app-global-menu>
  </header>
}

<main class="spen-main-layout" [class.has-header]="!isMobileApp">
  @if (authUserService.isLoggedIn) {
    <app-student-sidebar></app-student-sidebar>
  }
  <div class="prod-ly-content">
    <app-content></app-content>
  </div>
</main>

@if (authUserService.isLoggedIn && !isMobileApp) {
  <footer>
    <app-student-footer></app-student-footer>
  </footer>
}
